<template>
	<v-card>
		<v-snackbar color="primary" v-model="snackbar.status" :timeout="snackbar.timeout" centered dark>
			<v-icon class="mr-1 mb-1" size="21px">mdi-alert</v-icon>Nenhum titulo selecionado para impressão.
		</v-snackbar>
		<v-dialog v-model="dialogLoading" hide-overlay persistent width="400">
			<v-card color="primary" dark>
				<v-card-text class="pt-3">
					Aguarde enquanto o documento é gerado!
					<v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
				</v-card-text>
			</v-card>
		</v-dialog>
		<v-dialog v-model="dialogErro.status" persistent>
			<CardDialog :dialog="dialogErro" />
		</v-dialog>
		<v-dialog persistent v-model="dialogDetalhe" scrollable width="100%">
			<v-card color="primary" class="white--text">
				<v-progress-linear indeterminate absolute :active="carregando" />
				<v-card-title v-if="dados2.lista" class="text-truncate">
					Emissão e Impressão
					<v-spacer />
					<v-menu offset-y>
						<template v-slot:activator="{ on, attrs }">
							<v-btn v-bind="attrs" v-on="on" small>
								<v-icon color="primary">mdi-printer</v-icon>Imprimir
							</v-btn>
						</template>
						<v-list>
							<v-list-item
								v-for="sm in botaoFormato"
								:key="sm.to"
								@click="reimprimirDoc(sm.to, selected)"
								exact
							>
								<v-list-item-title>{{sm.titulo}}</v-list-item-title>
							</v-list-item>
						</v-list>
					</v-menu>
					<v-btn class="ml-2" small @click="dialogDetalhe = false, selected = []">
						<v-icon color="primary">mdi-close</v-icon>Fechar
					</v-btn>
				</v-card-title>
				<v-card-text v-if="carregando">
					<v-skeleton-loader class="mx-auto" width="100%" height="300" type="image, image"></v-skeleton-loader>
				</v-card-text>
				<v-card-text class="pb-0" v-else scrollable>
					<v-simple-table v-if="dados2.lista" light dense class="rounded-0">
						<thead>
							<tr class="grey lighten-1">
								<th class="pr-0">Selecionar</th>
								<th class="text-truncate">Cliente</th>
								<th class="text-truncate">Titulo</th>
								<th class="text-truncate text-center">Digito</th>
								<th class="text-truncate text-center">Data de movimento</th>
								<th class="text-truncate text-center">Data de vencimento</th>
								<th class="text-truncate">Valor juros</th>
								<th class="text-truncate">Valor saldo</th>
								<th class="text-center">Status</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(t, i) in dados2.lista" :key="i">
								<td width="80px" class="pr-0">
									<v-checkbox
										class="ml-3 mb-n2 mt-2"
										v-model="selected"
										:value="t"
										:disabled="t.dtvencimento < dataAtual || t.flagexportado == 'F'"
									></v-checkbox>
								</td>
								<td class="text-truncate">{{t.idcliente}} - {{t.cliente}}</td>
								<td>{{t.titulo}}</td>
								<td class="text-center">{{t.digito}}</td>
								<td class="text-center">{{t.dtmovimento | formataData}}</td>
								<td class="text-center">{{t.dtvencimento | formataData}}</td>
								<td>{{t.jurostitulo | formataDinheiro}}</td>
								<td>{{t.valorliqtitulo | formataDinheiro}}</td>
								<td class="text-center" style="min-width: 120px">
									<v-progress-circular indeterminate color="primary" size="25" v-if="carregaEmissao"></v-progress-circular>
									<v-btn
										v-else-if="t.flagexportado == 'F' && t.dtvencimento > dataAtual"
										:disabled="carregando"
										class="px-2"
										elevation="0"
										color="primary"
										small
										@click="emitirBoleto(t)"
									>
										<v-icon class="pr-1">mdi-barcode</v-icon>Gerar
									</v-btn>
									<v-chip
										v-else
										small
										:class="dataAtual > t.dtvencimento ? 'color: error' : 'color : success'"
									>{{ dataAtual > t.dtvencimento ? 'Vencido' : 'Emitido' }}</v-chip>
								</td>
							</tr>
						</tbody>
					</v-simple-table>
				</v-card-text>
				<v-card-actions class="pl-6 py-3">
					<span
						style="font-size: 14px"
					>*Boletos vencidos emitir e imprimir 2ª via pelo Aplicativo/Site do Banco Itaú</span>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-card-title class="title">
			<v-row no-gutters>
				<v-col class="d-none d-md-block pr-1">
					<InputDatePicker
						:disabled="carregando"
						v-model="busca.dtinicio"
						label="Data inicial"
						:outlined="true"
						:dense="true"
					/>
				</v-col>
				<v-col class="d-none d-md-block px-1">
					<InputDatePicker
						:disabled="carregando"
						v-model="busca.dtfim"
						label="Data final"
						:outlined="true"
						:dense="true"
					/>
				</v-col>
				<v-col class="d-none d-md-block px-1" v-if="usuario.idgrupo == 1">
					<v-autocomplete
						:items="filiaisFiltro"
						clearable
						item-text="filial"
						item-value="idfilial"
						label="Filial"
						outlined
						dense
						:disabled="carregando"
						v-model="busca.idfilial"
						hide-details
					></v-autocomplete>
				</v-col>
				<v-col class="d-none d-md-block px-1">
					<v-text-field
						label="Título"
						outlined
						dense
						:disabled="carregando"
						v-model="busca.titulo"
						hide-details
					></v-text-field>
				</v-col>
				<v-bottom-sheet class="d-flex d-md-none" v-model="sheet">
					<v-sheet class="text-center" height="100%">
						<v-row class="pa-3">
							<v-col cols="6" class="mb-n3 px-2">
								<InputDatePicker
									:disabled="carregando"
									v-model="busca.dtinicio"
									label="Data inicial"
									:outlined="true"
									:dense="true"
								/>
							</v-col>
							<v-col cols="6" class="mb-n3 px-2">
								<InputDatePicker
									:disabled="carregando"
									v-model="busca.dtfim"
									label="Data final"
									:outlined="true"
									:dense="true"
								/>
							</v-col>
							<v-col cols="6" class="mb-n8 px-2" v-if="usuario.idgrupo == 1">
								<v-autocomplete
									:items="filiaisFiltro"
									clearable
									item-text="filial"
									item-value="idfilial"
									label="Filial"
									outlined
									dense
									:disabled="carregando"
									v-model="busca.idfilial"
									hide-details
								></v-autocomplete>
							</v-col>
							<v-col :cols="usuario.idgrupo == 1 ? 6 : 12" class="mb-n8 px-2">
								<v-text-field label="Título" outlined dense :disabled="carregando" v-model="busca.titulo"></v-text-field>
							</v-col>
							<v-col cols="6">
								<v-btn text class="mt-n3" color="primary" @click="sheet = !sheet">Cancelar</v-btn>
							</v-col>
							<v-col cols="6">
								<v-btn text class="mt-n3" color="primary" @click="listar(0), sheet = !sheet">Filtrar</v-btn>
							</v-col>
						</v-row>
					</v-sheet>
				</v-bottom-sheet>
				<v-col class="pl-1">
					<v-autocomplete
						no-filter
						v-model="busca.idcliente"
						outlined
						dense
						label="Cliente"
						:search-input.sync="searchMobile"
						:items="items"
						:loading="carregando"
						item-text="nome"
						item-value="idcliente"
						class="d-flex d-md-none"
						append-outer-icon="mdi-menu"
						@click:append-outer="sheet = !sheet"
						hide-details
						clearable
					></v-autocomplete>
					<v-autocomplete
						no-filter
						v-model="busca.idcliente"
						outlined
						dense
						label="Cliente"
						:search-input.sync="search"
						:items="items"
						:loading="carregando"
						item-text="nome"
						item-value="idcliente"
						class="d-none d-md-block"
						hide-details
						clearable
					></v-autocomplete>
				</v-col>
				<v-col cols="auto" class="ml-2">
					<v-btn
						:disabled="carregando"
						class="mt-1"
						color="primary"
						elevation="0"
						fab
						x-small
						@click="listar(0)"
					>
						<v-icon>mdi-magnify</v-icon>
					</v-btn>
				</v-col>
			</v-row>
		</v-card-title>
		<v-divider />
		<v-progress-linear indeterminate absolute :active="carregando" />
		<v-card-text>
			<v-simple-table>
				<template v-slot:default>
					<thead>
						<tr>
							<th class="text-left">Filial</th>
							<th class="text-left">Cliente</th>
							<th class="text-left">Titulo</th>
							<th class="text-center text-truncate">Parcelas pendentes</th>
							<th class="text-center text-truncate">Data de movimento</th>
							<th class="text-center text-truncate">Data do próximo vencimento</th>
							<th class="text-center text-truncate">Total juros</th>
							<th class="text-left">Valor total</th>
							<th></th>
						</tr>
					</thead>
					<tbody>
						<template v-if="dados.total > 0">
							<tr v-for="(u, i) in dados.lista" :key="i">
								<td class="text-truncate">{{u.idfilial}} - {{u.filial}}</td>
								<td class="text-truncate">{{u.idcliente}} - {{u.cliente}}</td>
								<td>{{u.titulo}}</td>
								<td class="text-center text-truncate">{{u.digitoinicial}}/{{u.digitofinal}}</td>
								<td class="text-center text-truncate">{{u.dtmovimento}}</td>
								<td class="text-center text-truncate">{{u.dtvencimento }}</td>
								<td class="text-center text-truncate">{{u.jurostitulo | formataDinheiro}}</td>
								<td>{{u.valorliqtitulo | formataDinheiro}}</td>
								<td class="text-truncate text-center">
									<v-btn
										:disabled="carregando"
										class="px-2"
										elevation="0"
										color="primary"
										small
										@click="detalharTitulo(u)"
									>
										<v-icon class="pr-1" small>mdi-magnify-plus-outline</v-icon>Abrir Título
									</v-btn>
								</td>
							</tr>
						</template>
						<template v-else>
							<tr>
								<td class="text-center" colspan="10">Nenhum registro encontrado.</td>
							</tr>
						</template>
					</tbody>
				</template>
			</v-simple-table>
			<Paginacao
				:total="dados.total"
				@atualizar="listar"
				:carregando="carregando"
				:pg="pgSelecionada"
			/>
		</v-card-text>
		<v-progress-linear indeterminate absolute :active="carregando" />
	</v-card>
</template>


<script>
import axios from "axios";
import { mapState } from "vuex";
import mixinFilial from "../../util/mixinFilial";
import CardDialog from "../Widgets/CardDialog";
import Paginacao from "../Widgets/Paginacao";
import InputDatePicker from "../Widgets/InputDatePicker.vue";
import html2pdf from "html2pdf.js";

export default {
	name: "ParcelamentoBoleto",
	components: { CardDialog, InputDatePicker, Paginacao },
	mixins: [mixinFilial],
	data: () => ({
		snackbar: { status: false, timeout: 2000 },
		carregaEmissao: false,
		dataAtual: `${new Date(
			new Date().getFullYear(),
			new Date().getMonth() + 1,
			0
		).getFullYear()}-${
			(new Date(
				new Date().getFullYear(),
				new Date().getMonth() + 1,
				0
			).getMonth() +
				1 <
			10
				? "0"
				: "") +
			(new Date().getMonth() + 1)
		}-${
			(new Date(
				new Date().getFullYear(),
				new Date().getMonth(),
				new Date().getDate()
			).getDate() < 10
				? "0"
				: "") + new Date().getDate()
		}`,
		botaoFormato: [
			{ titulo: "Formato Boleto", to: 1 },
			{ titulo: "Formato Carnê", to: 2 },
		],
		dialogDetalhe: false,
		selected: [],
		sheet: false,
		carregando: false,
		dialogLoading: false,
		dialogErro: {
			status: false,
			title: "",
			msg: "",
			icon: "",
			iconColor: "",
		},
		dados: { total: 0 },
		dados2: { total: 0 },
		busca: {
			dtinicio: `${new Date().getFullYear()}-${
				(new Date(
					new Date().getFullYear(),
					new Date().getMonth() + 1,
					0
				).getMonth() +
					1 <
				10
					? "0"
					: "") +
				(new Date().getMonth() + 1)
			}-01`,
			dtfim: `${new Date(
				new Date().getFullYear(),
				new Date().getMonth() + 1,
				0
			).getFullYear()}-${
				(new Date(
					new Date().getFullYear(),
					new Date().getMonth() + 1,
					0
				).getMonth() +
					1 <
				10
					? "0"
					: "") +
				(new Date().getMonth() + 1)
			}-${new Date(
				new Date().getFullYear(),
				new Date().getMonth() + 1,
				0
			).getDate()}`,
			idcliente: null,
			titulo: null,
		},
		aguardarBusca: "",
		nomeLimit: 50,
		clientes: [],
		search: null,
		searchMobile: null,
		pgSelecionada: 0,
		dataVencimento: [],
	}),
	computed: {
		...mapState(["backendUrl", "pgLimit", "timeLimit", "usuario"]),
		items() {
			if (this.clientes == null) return;

			this.clientes.forEach((cliente) => {
				if (cliente.nome.length > this.nomeLimit) {
					cliente.nome =
						cliente.nome.slice(0, this.nomeLimit) + "...";
				}
			});

			return this.clientes;
		},
		filiaisFiltro() {
			if (this.filiais.lista) {
				return this.filiais.lista.filter((v) => {
					return (
						v.idfilial != 6 &&
						v.idfilial != 12 &&
						v.idfilial != 25 &&
						v.idfilial != 29 &&
						v.idfilial != 33 &&
						v.idfilial != 37
					);
				});
			} else {
				return [];
			}
		},
	},
	methods: {
		carregarClientes(val) {
			clearTimeout(this.aguardarBusca);
			this.aguardarBusca = setTimeout(() => {
				return axios
					.post(`${this.backendUrl}cliente/listar`, {
						limit: 30,
						offset: 0,
						busca: val || null,
					})
					.then((res) => {
						this.clientes = res.data.lista;
						this.carregando = false;
					})
					.catch(() => {
						this.carregando = false;
					});
			}, this.timeLimit);
		},
		listar(pg) {
			this.pgSelecionada = pg;
			this.carregando = true;
			return axios
				.post(`${this.backendUrl}parcelamento/carne/listar`, {
					limit: this.pgLimit,
					offset: this.pgLimit * pg,
					dtini: this.busca.dtinicio || null,
					dtfim: this.busca.dtfim || null,
					idfilial: this.busca.idfilial || null,
					idcliente: this.busca.idcliente || null,
					titulo: parseInt(this.busca.titulo) || null,
				})
				.then((res) => {
					this.dados = res.data;
					this.carregando = false;
				})
				.catch(() => {
					this.carregando = false;
				});
		},
		detalharTitulo(titulo) {
			this.dialogDetalhe = true;
			this.carregando = true;
			return axios
				.post(`${this.backendUrl}parcelamento/carne/detalhe/listar`, {
					limit: this.pgLimit,
					dtini: this.busca.dtinicio || null,
					dtfim: this.busca.dtfim || null,
					idfilial: titulo.idfilial || null,
					idcliente: titulo.idcliente || null,
					titulo: parseInt(titulo.titulo) || null,
				})
				.then((res) => {
					this.dados2 = res.data;
					this.carregando = false;
				})
				.catch(() => {
					this.carregando = false;
				});
		},
		emitirBoleto(titulo) {
			this.carregaEmissao = true;
			return axios
				.post(`${this.backendUrl}parcelamento/boleto/emitir`, {
					...titulo,
				})
				.then((res) => {
					if (res.data) {
						// this.detalharTitulo(titulo);
						this.carregaEmissao = false;
					} else {
						this.dialogErro.title = "Erro";
						if (res.data.erro) {
							this.dialogErro.msg = res.data.erro;
						} else {
							this.dialogErro.msg =
								"Não foi possível emitir o documento";
						}
						this.dialogErro.icon = "mdi-alert-circle-outline";
						this.dialogErro.iconColor = "red";
						this.dialogErro.status = true;
						this.carregaEmissao = false;
					}
				})
				.catch((e) => {
					this.carregaEmissao = false;
					this.carregando = false;
					this.dialogLoading = false;
					this.dialogErro.title = "Erro";
					if (e.response.data.erro) {
						this.dialogErro.msg = e.response.data.erro;
					} else {
						this.dialogErro.msg =
							"Não foi possível emitir o documento";
					}
					this.dialogErro.icon = "mdi-alert-circle-outline";
					this.dialogErro.iconColor = "red";
					this.dialogErro.status = true;
				});
		},
		reimprimirDoc(formato, titulo) {
			let dados = titulo;
			if (titulo.length == 0) {
				this.snackbar.status = true;
			} else {
				if (formato == 1) {
					this.reimprimirBoleto(dados);
				} else if (formato == 2) {
					this.reimprimirCarne(dados);
				}
			}
		},
		reimprimirBoleto(titulo) {
			this.carregando = true;
			this.dialogLoading = true;
			this.dataVencimento = [];
			var dados = { parcelamentos: [] };
			dados.parcelamentos = titulo.sort((a, b) => a.digito - b.digito);
			return axios
				.post(`${this.backendUrl}parcelamento/carne/reimprimir`, dados)
				.then((res) => {
					this.carregando = false;
					this.dialogLoading = false;
					if (res.data) {
						var htmlContent = ``;
						for (let i = 0; i < res.data.length; i++) {
							if (i > 0) {
								htmlContent += `<p style="height: 179px">&nbsp;</p>`;
							}
							this.dataVencimento[i] = this.formataData(
								dados.parcelamentos[i].dtvencimento
							);
							htmlContent += `
                            <!DOCTYPE html>
                                <html>
                                    <head>
                                        <title>Boleto Online</title>
                                        <meta http-equiv="Content-Type" content="text/html; charset=iso-8859-1">
                                    </head>

                                    <body style="padding:15pt !important;">
										<div style="height: 900px;">
											<table width="700" border="0" cellpadding="0" cellspacing="1" style="margin-left:20px;margin-top:20px;font-family:Arial !important;">
												<tr>
													<td>
														<table width="100%" border="0" cellspacing="0" cellpadding="0">
															<tr>
																<td colspan="2" rowspan="2" valign="bottom" style="color:white; height:28px;">
																</td>
																<td width="45%" valign="bottom">
																	<div align="right">
																	</div>
																</td>
															</tr>
															<tr>
																<td>
																	<img src="data:image/gif;base64,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" />
																	<img src="data:image/gif;base64,R0lGODlhVgArALMAAIiIiLu7u93d3ZmZmREREe7u7qqqqszMzFVVVSIiImZmZjMzM0RERHd3dwAAAP///yH5BAAAAAAALAAAAABWACsAAAT/8MlJq7046827/2AojmRpnmiqrmzrvnAsz3Rt33iu73zv/xIBwEEkAAqbAdEhyCSIgc5zSV1GS4EqMXHICAjL5kUJlWqr11EBfE5kEFRx5UBNa6bnMmlIBEgYSwYXBlVyE4R1JAJLCyYDCg4IE3R9FmuFFAdwaCQLRYYpiA5+FZtsTBRUp3YffA6CLAdTBEgUiAkNYalEC66sHZcODCwFqqzBBq6GRJJkDr8cyrFUAxaQDgoP0hMLsM7QGsHZLFlUDLUPiLTaumNWIa5dxBKukg8FU9XsRKAT3xVnKnhy0CjGNVTX7O1D5U7PhICTlpCC4UxQnir6KPzbVYXCthMFaADAGSeh4oOL1CxsfKiFwqaCKdgQoHCwC8olGf29+8CmwYqDCJC4GobhY4WVHCiNWvHlorwLRjXu7CAKHIkDpxJliKrTYbR2K0KeOrKBa8mpX/kBWcu2rdu3cOPKnUu3rt27ePPq3RABADs=" />
																</td>
																<td valign="bottom" style="font-size:12.5px;font-weight:bold;">
																	<div align="right">
																		<img width="80px" src="data:image/jpeg;base64,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" />
																		<br />
																		<span>Recibo do Pagador</span>
																	</div>
																</td>
															</tr>
														</table>
													</td>
												</tr>
												<tr>
													<td>
														<table width="100%" height="315" border="1" cellpadding="0" cellspacing="0" bordercolor="#000000">
															<tr>
																<td colspan="3" valign="bottom">
																	<table width="100%" border="0" cellspacing="0" cellpadding="1">
																		<tr>
																			<td width="6">&nbsp;</td>
																			<td width="438" style="font-size:11.5px">
																				Local de Pagamento
																			</td>
																		</tr>
																		<tr>
																			<td width="6">&nbsp;</td>
																			<td width="438" style="font-size:10.5px">
																				ATÉ O VENCIMENTO, PAGUE EM QUALQUER BANCO OU CORRESPONDENTE
																				NÃO BANCÁRIO. APÓS O VENCIMENTO, ACESSE ITAU.COM.BR/BOLETOS
																				E PAGUE EM QUALQUER BANCO OU CORRESPONDENTE NÃO BANCÁRIO.
																			</td>
																		</tr>
																	</table>
																</td>
																<td width="250" valign="top">
																	<table width="100%" border="0" cellspacing="0" cellpadding="1">
																		<tr>
																			<td width="6">&nbsp;</td>
																			<td width="438" style="font-size:11.5px">
																				Vencimento
																			</td>
																		</tr>
																		<tr>
																			<td width="6">&nbsp;</td>
																			<td width="438" style="font-size:13.5px; font-weight:bold;" align="center">
																				${this.dataVencimento[i]}
																			</td>
																		</tr>
																	</table>
																</td>
															</tr>
															<tr>
																<td colspan="3" valign="bottom">
																	<table width="100%" border="0" cellspacing="0" cellpadding="1">
																		<tr>
																			<td width="6">&nbsp;</td>
																			<td width="438" style="font-size:11.5px;">Beneficiário</td>
																		</tr>
																		<tr>
																			<td width="6">&nbsp;</td>
																			<td width="438" style="font-size:11.5px;">
																				${res.data[i].cedente}
																			</td>
																		</tr>
																	</table>
																</td>
																<td width="250">
																	<div align="right">
																		<table width="100%" border="0" cellspacing="0" cellpadding="1">
																			<tr>
																				<td colspan="2">
																					<div align="left" style="font-size:11.5px;">&nbsp; Agência/Código do beneficiário</div>
																				</td>
																			</tr>
																			<tr>
																				<td width="96%" valign="bottom">
																					<div align="right" style="font-size:11.5px;">
																						${res.data[i].agencia}/${res.data[i].conta}-${res.data[i].digito}
																					</div>
																				</td>
																				<td width="4%">&nbsp;</td>
																			</tr>
																		</table>
																	</div>
																</td>
															</tr>
															<tr>
																<td width="150" height="32" valign="top">
																	<div align="center">
																		<table width="100%" border="0" cellspacing="0" cellpadding="1">
																			<tr>
																				<td>
																					<div align="left" style="font-size:11.5px;">&nbsp; Data do Documento</div>
																				</td>
																			</tr>
																			<tr>
																				<td>
																					<div align="center" style="font-size:11.5px;">
																						${new Date(new Date()).toLocaleDateString("pt-BR")}
																					</div>
																				</td>
																			</tr>
																		</table>
																	</div>
																</td>
																<td width="150" valign="top">
																	<div align="center">
																		<table width="100%" border="0" cellspacing="0" cellpadding="1">
																			<tr>
																				<td>
																					<div align="left" style="font-size:11.5px;">&nbsp; Espécie Doc</div>
																				</td>
																			</tr>
																			<tr>
																				<td>
																					<div align="center" style="font-size:11.5px;">DM</div>
																				</td>
																			</tr>
																		</table>
																	</div>
																</td>
																<td width="150" height="32" valign="top">
																	<div align="center">
																		<table width="100%" border="0" cellspacing="0" cellpadding="1">
																			<tr>
																				<td>
																					<div align="left" style="font-size:11.5px;">&nbsp; Aceite</div>
																				</td>
																			</tr>
																			<tr>
																				<td>
																					<div align="center" style="font-size:11.5px;">
																						${res.data[i].aceite}
																					</div>
																				</td>
																			</tr>
																		</table>
																	</div>
																</td>
																<td width="250" height="28" valign="bottom">
																	<div align="right">
																		<table width="100%" border="0" cellspacing="0" cellpadding="1">
																			<tr>
																				<td colspan="2">
																					<div align="left" style="font-size:11.5px;">&nbsp; Nosso Número</div>
																				</td>
																			</tr>
																			<tr>
																				<td width="96%">
																					<div align="right" style="font-size:11.5px;">
																						${res.data[i].carteira}/${res.data[i].calculanossonumero}-${res.data[i].calculadac2}
																					</div>
																				</td>
																				<td width="4%">&nbsp;</td>
																			</tr>
																		</table>
																	</div>
																</td>
															</tr>
															<tr>
																<td width="150" height="32" valign="top">
																	<table width="100%" border="0" cellspacing="0" cellpadding="1">
																		<tr>
																			<td>
																				<div align="left" style="font-size:11.5px;">&nbsp; Uso do Banco</div>
																			</td>
																		</tr>
																		<tr>
																			<td>
																				<div align="center"></div>
																			</td>
																		</tr>
																	</table>
																</td>
																<td width="150" height="32" valign="top">
																	<div align="center">
																		<table width="100%" border="0" cellspacing="0" cellpadding="1">
																			<tr>
																				<td>
																					<div align="left" style="font-size:11.5px;">&nbsp;Carteira</div>
																				</td>
																			</tr>
																			<tr>
																				<td>
																					<div align="center" style="font-size:11.5px;">
																						${res.data[i].carteira}
																					</div>
																				</td>
																			</tr>
																		</table>
																	</div>
																</td>
																<td width="150" height="32" valign="top">
																	<table width="100%" border="0" cellspacing="0" cellpadding="1">
																		<tr>
																			<td>
																				<div align="left" style="font-size:11.5px;">&nbsp;&nbsp; Espécie</div>
																			</td>
																		</tr>
																		<tr>
																			<td>
																				<div align="center" style="font-size:11.5px;">R$</div>
																			</td>
																		</tr>
																	</table>
																</td>
																<td width="250" height="28" valign="top">
																	<div align="right">
																		<table width="100%" border="0" cellpadding="1" cellspacing="0">
																			<tr>
																				<td colspan="2">
																					<div align="left" style="font-size:11.5px;">&nbsp; (=) Valor do Documento</div>
																				</td>
																			</tr>
																			<tr>
																				<td width="96%">
																					<div align="right" style="font-size:13.5px;font-weight:bold;">
																						${parseFloat(dados.parcelamentos[i].valorliqtitulo).toLocaleString("pt-br",{style: "currency",currency:"BRL",})}
																					</div>
																				</td>
																				<td width="4%">&nbsp;</td>
																			</tr>
																		</table>
																	</div>
																</td>
															</tr>
															<tr>
																<td height="90" colspan="3" rowspan="3" valign="top">
																	<table width="100%" border="0" cellspacing="0" cellpadding="1">
																		<tr>
																			<td width="6">&nbsp;</td>
																			<td colspan="2" style="font-size:11.5px;">
																				Instruções (Todas as informações abaixo são de exclusiva responsabilidade do beneficiário)
																			</td>
																		</tr>
																		<tr>
																			<td width="6">&nbsp;</td>
																			<td width="438" style="font-size:11.5px;font-weight:bold;">
																				<span>
																					${res.data[i].instrucoes[0]}</br>
																					${res.data[i].instrucoes[1]}</br>
																					${res.data[i].instrucoes[2]}</br>
																				</span>
																			</td>
																		</tr>
																	</table>
																</td>
																<td width="250" height="28" valign="bottom">
																	<table width="100%" border="0" cellpadding="1" cellspacing="0">
																		<tr>
																			<td colspan="2" style="font-size:11.5px;">
																				<div align="left">&nbsp; (-) Desconto/Abatimento</div>
																			</td>
																		</tr>
																		<tr>
																			<td width="96%">
																				<div align="right"></div>
																			</td>
																			<td width="4%">&nbsp;</td>
																		</tr>
																	</table>
																</td>
															</tr>
															<tr>
																<td width="250" height="28" valign="bottom">
																	<table width="100%" border="0" cellpadding="1" cellspacing="0">
																		<tr>
																			<td colspan="2" style="font-size:11.5px;">
																				<div align="left">&nbsp; (+) Mora/Multa</div>
																			</td>
																		</tr>
																		<tr>
																			<td width="96%">
																				<div align="right"></div>
																			</td>
																			<td width="4%">&nbsp;</td>
																		</tr>
																	</table>
																</td>
															</tr>
															<tr>
																<td width="250" height="28" valign="bottom">
																	<table width="100%" border="0" cellpadding="1" cellspacing="0">
																		<tr>
																			<td colspan="2" style="font-size:11.5px;">
																				<div align="left">&nbsp; (=) Valor Cobrado</div>
																			</td>
																		</tr>
																		<tr>
																			<td width="96%">
																				<div align="right"></div>
																			</td>
																			<td width="4%">&nbsp;</td>
																		</tr>
																	</table>
																</td>
															</tr>
															<tr>
																<td colspan="4" valign="top">
																	<table width="100%" border="0" cellspacing="0" cellpadding="1">
																		<tr>
																			<td colspan="3" style="font-size:11.5px">&nbsp; Pagador</td>
																		</tr>
																		<tr>
																			<td width="10">&nbsp;</td>
																			<td width="434" style="font-size:11.5px">
																				<span>
																					${res.data[i].cliente}<br>
																					${res.data[i].endereco}${res.data[i].cep}
																					${res.data[i].cidade}-${res.data[i].uf}
																				</span>
																			</td>
																			<td width="250" style="font-size:11.5px">
																				<span>
																					CNPJ/CPF ${res.data[i].cpfcnpj}
																				</span>
																			</td>
																		</tr>
																		<tr>
																			<td colspan="3" style="font-size:11.5px">&nbsp; Beneficiário</td>
																		</tr>
																		<tr>
																			<td width="10">&nbsp;</td>
																			<td width="428">
																				<span style="font-size:11.5px">
																					${res.data[i].empresa} <br>
																					${res.data[i].empresaendereco} - ${res.data[i].empresacep} - ${res.data[i].empresacidade} <br>
																				</span>
																			</td>
																			<td width="250" style="font-size:11.5px">
																				<span>
																				CNPJ/CPF ${res.data[i].empresacnpj}
																				</span>
																			</td>
																		</tr>
																	</table>
																</td>
															</tr>
														</table>
													</td>
												</tr>
												<tr>
													<td>
														<div align="right" style="font-size:11.5px;font-weight:bold;">
															Autenticação Mecânica
														</div>
													</td>
												</tr>
												<tr>
													<td height="5">
														.............................................................................................................................................................
													</td>
												</tr>
											</table>
											<table width="700" border="0" cellpadding="0" cellspacing="1" style="margin-left:20px;font-family:Arial !important;">
												<tr>
													<td colspan="2">
														<table width="100%"  border="0" cellspacing="0" cellpadding="0">
															<tr>
																<td colspan="2" rowspan="2" valign="bottom" style="color:white;height:28px;">
																</td>
																<td width="72%" valign="bottom"><div align="right"></div></td>
															</tr>
															<tr>
																<td>
																	<img src="data:image/gif;base64,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" />
																	<img src="data:image/gif;base64,R0lGODlhVgArALMAAIiIiLu7u93d3ZmZmREREe7u7qqqqszMzFVVVSIiImZmZjMzM0RERHd3dwAAAP///yH5BAAAAAAALAAAAABWACsAAAT/8MlJq7046827/2AojmRpnmiqrmzrvnAsz3Rt33iu73zv/xIBwEEkAAqbAdEhyCSIgc5zSV1GS4EqMXHICAjL5kUJlWqr11EBfE5kEFRx5UBNa6bnMmlIBEgYSwYXBlVyE4R1JAJLCyYDCg4IE3R9FmuFFAdwaCQLRYYpiA5+FZtsTBRUp3YffA6CLAdTBEgUiAkNYalEC66sHZcODCwFqqzBBq6GRJJkDr8cyrFUAxaQDgoP0hMLsM7QGsHZLFlUDLUPiLTaumNWIa5dxBKukg8FU9XsRKAT3xVnKnhy0CjGNVTX7O1D5U7PhICTlpCC4UxQnir6KPzbVYXCthMFaADAGSeh4oOL1CxsfKiFwqaCKdgQoHCwC8olGf29+8CmwYqDCJC4GobhY4WVHCiNWvHlorwLRjXu7CAKHIkDpxJliKrTYbR2K0KeOrKBa8mpX/kBWcu2rdu3cOPKnUu3rt27ePPq3RABADs=" />
																</td>
																<td valign="bottom" style="white-space: nowrap;">
																	<div align="right" style="font-size:13.5px;font-weight:bold;">
																		<p style="white-space: nowrap;">
																			${res.data[i].numeroboleto}
																		</p>
																	</div>
																</td>
															</tr>
														</table>
													</td>
												</tr>
												<tr>
													<td colspan="2">
														<table width="100%" height="315" border="1" cellpadding="0" cellspacing="0" bordercolor="#000000">
															<tr>
																<td colspan="3" valign="bottom">
																	<table width="100%" border="0" cellspacing="0" cellpadding="1">
																		<tr>
																			<td width="6">&nbsp;</td>
																			<td width="438" style="font-size:11.5px">
																				Local de Pagamento
																			</td>
																		</tr>
																		<tr>
																			<td width="6">&nbsp;</td>
																			<td width="438" style="font-size:10.5px">
																				ATÉ O VENCIMENTO, PAGUE EM QUALQUER BANCO OU CORRESPONDENTE
																				NÃO BANCÁRIO. APÓS O VENCIMENTO, ACESSE ITAU.COM.BR/BOLETOS
																				E PAGUE EM QUALQUER BANCO OU CORRESPONDENTE NÃO BANCÁRIO.
																			</td>
																		</tr>
																	</table>
																</td>
																<td width="250" valign="top">
																	<table width="100%" border="0" cellspacing="0" cellpadding="1">
																		<tr>
																			<td width="6">&nbsp;</td>
																			<td width="438" style="font-size:11.5px">
																				Vencimento
																			</td>
																		</tr>
																		<tr>
																			<td width="6">&nbsp;</td>
																			<td width="438" style="font-size:13.5px; font-weight:bold;" align="center">
																				${this.dataVencimento[i]}
																			</td>
																		</tr>
																	</table>
																</td>
															</tr>
															<tr>
																<td colspan="3" valign="bottom">
																	<table width="100%" border="0" cellspacing="0" cellpadding="1">
																		<tr>
																			<td width="6">&nbsp;</td>
																			<td width="438" style="font-size:11.5px;">Beneficiário</td>
																		</tr>
																		<tr>
																			<td width="6">&nbsp;</td>
																			<td width="438" style="font-size:11.5px;">
																				${res.data[i].cedente}
																			</td>
																		</tr>
																	</table>
																</td>
																<td width="250">
																	<div align="right">
																		<table width="100%" border="0" cellspacing="0" cellpadding="1">
																			<tr>
																				<td colspan="2">
																					<div align="left" style="font-size:11.5px;">&nbsp; Agência/Código do beneficiário</div>
																				</td>
																			</tr>
																			<tr>
																				<td width="96%" valign="bottom">
																					<div align="right" style="font-size:11.5px;">
																						${res.data[i].agencia}/${res.data[i].conta}-${res.data[i].digito}
																					</div>
																				</td>
																				<td width="4%">&nbsp;</td>
																			</tr>
																		</table>
																	</div>
																</td>
															</tr>
															<tr>
																<td width="150" height="32" valign="top">
																	<div align="center">
																		<table width="100%" border="0" cellspacing="0" cellpadding="1">
																			<tr>
																				<td>
																					<div align="left" style="font-size:11.5px;">&nbsp; Data do Documento</div>
																				</td>
																			</tr>
																			<tr>
																				<td>
																					<div align="center" style="font-size:11.5px;">
																						${new Date(new Date()).toLocaleDateString("pt-BR")}
																					</div>
																				</td>
																			</tr>
																		</table>
																	</div>
																</td>
																<td width="150" valign="top">
																	<div align="center">
																		<table width="100%" border="0" cellspacing="0" cellpadding="1">
																			<tr>
																				<td>
																					<div align="left" style="font-size:11.5px;">&nbsp; Espécie Doc</div>
																				</td>
																			</tr>
																			<tr>
																				<td>
																					<div align="center" style="font-size:11.5px;">DM</div>
																				</td>
																			</tr>
																		</table>
																	</div>
																</td>
																<td width="150" height="32" valign="top">
																	<div align="center">
																		<table width="100%" border="0" cellspacing="0" cellpadding="1">
																			<tr>
																				<td>
																					<div align="left" style="font-size:11.5px;">&nbsp; Aceite</div>
																				</td>
																			</tr>
																			<tr>
																				<td>
																					<div align="center" style="font-size:11.5px;">
																						${res.data[i].aceite}
																					</div>
																				</td>
																			</tr>
																		</table>
																	</div>
																</td>
																<td width="250" height="28" valign="bottom">
																	<div align="right">
																		<table width="100%" border="0" cellspacing="0" cellpadding="1">
																			<tr>
																				<td colspan="2">
																					<div align="left" style="font-size:11.5px;">&nbsp; Nosso Número</div>
																				</td>
																			</tr>
																			<tr>
																				<td width="96%">
																					<div align="right" style="font-size:11.5px;">
																						${res.data[i].carteira}/${res.data[i].calculanossonumero}-${res.data[i].calculadac2}
																					</div>
																				</td>
																				<td width="4%">&nbsp;</td>
																			</tr>
																		</table>
																	</div>
																</td>
															</tr>
															<tr>
																<td width="150" height="32" valign="top">
																	<table width="100%" border="0" cellspacing="0" cellpadding="1">
																		<tr>
																			<td>
																				<div align="left" style="font-size:11.5px;">&nbsp; Uso do Banco</div>
																			</td>
																		</tr>
																		<tr>
																			<td>
																				<div align="center"></div>
																			</td>
																		</tr>
																	</table>
																</td>
																<td width="150" height="32" valign="top">
																	<div align="center">
																		<table width="100%" border="0" cellspacing="0" cellpadding="1">
																			<tr>
																				<td>
																					<div align="left" style="font-size:11.5px;">&nbsp;Carteira</div>
																				</td>
																			</tr>
																			<tr>
																				<td>
																					<div align="center" style="font-size:11.5px;">
																						${res.data[i].carteira
																						}
																					</div>
																				</td>
																			</tr>
																		</table>
																	</div>
																</td>
																<td width="150" height="32" valign="top">
																	<table width="100%" border="0" cellspacing="0" cellpadding="1">
																		<tr>
																			<td>
																				<div align="left" style="font-size:11.5px;">&nbsp;&nbsp; Espécie</div>
																			</td>
																		</tr>
																		<tr>
																			<td>
																				<div align="center" style="font-size:11.5px;">R$</div>
																			</td>
																		</tr>
																	</table>
																</td>
																<td width="250" height="28" valign="top">
																	<div align="right">
																		<table width="100%" border="0" cellpadding="1" cellspacing="0">
																			<tr>
																				<td colspan="2">
																					<div align="left" style="font-size:11.5px;">&nbsp; (=) Valor do Documento</div>
																				</td>
																			</tr>
																			<tr>
																				<td width="96%">
																					<div align="right" style="font-size:13.5px;font-weight:bold;">
																						${parseFloat(dados.parcelamentos[i].valorliqtitulo).toLocaleString("pt-br",{style: "currency",currency:"BRL",})}
																					</div>
																				</td>
																				<td width="4%">&nbsp;</td>
																			</tr>
																		</table>
																	</div>
																</td>
															</tr>
															<tr>
																<td height="90" colspan="3" rowspan="3" valign="top">
																	<table width="100%" border="0" cellspacing="0" cellpadding="1">
																		<tr>
																			<td width="6">&nbsp;</td>
																			<td colspan="2" style="font-size:11.5px;">
																				Instruções (Todas as informações abaixo são de exclusiva responsabilidade do beneficiário)
																			</td>
																		</tr>
																		<tr>
																			<td width="6">&nbsp;</td>
																			<td width="438" style="font-size:11.5px;font-weight:bold;">
																				<span>
																					${res.data[i].instrucoes[0]}</br>
																					${res.data[i].instrucoes[1]}</br>
																					${res.data[i].instrucoes[2]}</br>
																				</span>
																			</td>
																		</tr>
																	</table>
																</td>
																<td width="250" height="28" valign="bottom">
																	<table width="100%" border="0" cellpadding="1" cellspacing="0">
																		<tr>
																			<td colspan="2" style="font-size:11.5px;">
																				<div align="left">&nbsp; (-) Desconto/Abatimento</div>
																			</td>
																		</tr>
																		<tr>
																			<td width="96%">
																				<div align="right"></div>
																			</td>
																			<td width="4%">&nbsp;</td>
																		</tr>
																	</table>
																</td>
															</tr>
															<tr>
																<td width="250" height="28" valign="bottom">
																	<table width="100%" border="0" cellpadding="1" cellspacing="0">
																		<tr>
																			<td colspan="2" style="font-size:11.5px;">
																				<div align="left">&nbsp; (+) Mora/Multa</div>
																			</td>
																		</tr>
																		<tr>
																			<td width="96%">
																				<div align="right"></div>
																			</td>
																			<td width="4%">&nbsp;</td>
																		</tr>
																	</table>
																</td>
															</tr>
															<tr>
																<td width="250" height="28" valign="bottom">
																	<table width="100%" border="0" cellpadding="1" cellspacing="0">
																		<tr>
																			<td colspan="2" style="font-size:11.5px;">
																				<div align="left">&nbsp; (=) Valor Cobrado</div>
																			</td>
																		</tr>
																		<tr>
																			<td width="96%">
																				<div align="right"></div>
																			</td>
																			<td width="4%">&nbsp;</td>
																		</tr>
																	</table>
																</td>
															</tr>
															<tr>
																<td colspan="4" valign="top">
																	<table width="100%" border="0" cellspacing="0" cellpadding="1">
																		<tr>
																			<td colspan="3" style="font-size:11.5px">&nbsp; Pagador</td>
																		</tr>
																		<tr>
																			<td width="10">&nbsp;</td>
																			<td width="434" style="font-size:11.5px">
																				<span>
																					${res.data[i].cliente}<br>
																					${res.data[i].endereco} - ${res.data[i].cep} - ${res.data[i].cidade}-${res.data[i].uf}
																				</span>
																			</td>
																			<td width="250" style="font-size:11.5px">
																				<span>
																					CPF/CNPJ ${res.data[i].cpfcnpj}
																				</span>
																			</td>
																		</tr>
																		<tr>
																			<td colspan="3" style="font-size:11.5px">&nbsp; Beneficiário</td>
																		</tr>
																		<tr>
																			<td width="10">&nbsp;</td>
																			<td width="428">
																				<span style="font-size:11.5px">
																					${res.data[i].empresa} <br>
																					${res.data[i].empresaendereco} - ${res.data[i].empresacep} - ${res.data[i].empresacidade} <br>
																				</span>
																			</td>
																			<td width="250" style="font-size:11.5px">
																				<span>
																					CPF/CNPJ ${res.data[i].empresacnpj}
																				</span>
																			</td>
																		</tr>
																	</table>
																</td>
															</tr>
														</table>
													</td>
												</tr>
												<tr>
													<td>
						
														<img style="margin-top:5px; width:400px; height:45px;" src="data:image/png;base64,${res.data[i].base64}" />
													</td>
													<td width="315" valign="top">
														<div align="right" style="font-size:11.5px;font-weight:bold;">
															Autenticação Mecânica / Ficha de Compensação
														</div>
													</td>
												</tr>
											</table>
										</div>
                                    </body>
                                </html>`;
						}
						let data = new Date();
						let nome = `boleto_${
							data.toISOString().split(".")[0]
						}.pdf`;
						html2pdf(htmlContent, {
							margin: 10,
							filename: nome,
							image: { type: "jpeg", quality: 1 },
							html2canvas: { dpi: 192, letterRendering: true, scale: 2 },
							jsPDF: {
								unit: "pt",
								format: "a4",
								orientation: "portrait",
							},
						});
					} else {
						this.dialogErro.title = "Erro";
						if (res.data.erro) {
							this.dialogErro.msg = res.data.erro;
						} else {
							this.dialogErro.msg =
								"Não foi possível emitir o boleto";
						}
						this.dialogErro.icon = "mdi-alert-circle-outline";
						this.dialogErro.iconColor = "red";
						this.dialogErro.status = true;
					}
				})
				.catch(() => {
					this.carregando = false;
					this.dialogLoading = false;
					this.dialogErro.title = "Erro";
					this.dialogErro.msg = "Não foi possível emitir o boleto";
					this.dialogErro.icon = "mdi-alert-circle-outline";
					this.dialogErro.iconColor = "red";
					this.dialogErro.status = true;
				});
		},
		reimprimirCarne(titulo) {
			this.carregando = true;
			this.dialogLoading = true;
			this.dataVencimento = [];
			var dados = { parcelamentos: [] };
			dados.parcelamentos = titulo.sort((a, b) => a.digito - b.digito);
			return axios
				.post(`${this.backendUrl}parcelamento/carne/reimprimir`, dados)
				.then((res) => {
					this.carregando = false;
					this.dialogLoading = false;
					if (res.data) {
						var htmlContent = ``;
						for (let i = 0; i < res.data.length; i++) {
							if (
								i == 3 ||
								i == 6 ||
								i == 9 ||
								i == 12 ||
								i == 15 ||
								i == 18 ||
								i == 21
							) {
								htmlContent += `<p style="height: 42px;">&nbsp;</p>`;
							} else if (i == 0){
								htmlContent += `<p style="height: 10px;">&nbsp;</p>`;
							}

							this.dataVencimento[i] = this.formataData(
								dados.parcelamentos[i].dtvencimento
							);
							htmlContent += `
                                <!DOCTYPE html>
                                    <html>
                                        <head>
                                            <title>Carnê Online</title>
                                            <meta charset="UTF-8">
                                            <meta http-equiv="Content-Type" content="text/html; charset=iso-8859-1">
                                        </head>

                                        <body style="padding:15pt !important;">
											<div style="height: 300px;">
												<table width="740" cellpadding="0" cellspacing="1" style="margin-left:20px;margin-top:20px;font-family:Arial !important;">
													<tr>
														<td valign="top" width="180px">
															<table cellpadding="1" cellspacing="0">
																<tr height="30" style="font-size:9.5px">
																	<td style="border-right: 1px solid; border-bottom: 1px solid;" width="50%" align="center">
																		<img style="width:70px" src="data:image/gif;base64,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" />
																	</td>
																	<td style="border-right: 1px solid; border-bottom: 1px solid;" width="16%" align="center">
																		<img style="width:30px" src="data:image/gif;base64,R0lGODlhVgArALMAAIiIiLu7u93d3ZmZmREREe7u7qqqqszMzFVVVSIiImZmZjMzM0RERHd3dwAAAP///yH5BAAAAAAALAAAAABWACsAAAT/8MlJq7046827/2AojmRpnmiqrmzrvnAsz3Rt33iu73zv/xIBwEEkAAqbAdEhyCSIgc5zSV1GS4EqMXHICAjL5kUJlWqr11EBfE5kEFRx5UBNa6bnMmlIBEgYSwYXBlVyE4R1JAJLCyYDCg4IE3R9FmuFFAdwaCQLRYYpiA5+FZtsTBRUp3YffA6CLAdTBEgUiAkNYalEC66sHZcODCwFqqzBBq6GRJJkDr8cyrFUAxaQDgoP0hMLsM7QGsHZLFlUDLUPiLTaumNWIa5dxBKukg8FU9XsRKAT3xVnKnhy0CjGNVTX7O1D5U7PhICTlpCC4UxQnir6KPzbVYXCthMFaADAGSeh4oOL1CxsfKiFwqaCKdgQoHCwC8olGf29+8CmwYqDCJC4GobhY4WVHCiNWvHlorwLRjXu7CAKHIkDpxJliKrTYbR2K0KeOrKBa8mpX/kBWcu2rdu3cOPKnUu3rt27ePPq3RABADs=" />
																	</td>
																	<td style="border-bottom: 1px solid;font-weight:bold; "width="34%" align="center">Recibo do Pagador</td>
																</tr>
																<tr>
																	<td style="font-size:8.5px; border-right: 1px solid; border-bottom: 1px solid;">
																		<table width="100%" cellspacing="1" cellpadding="1">
																			<tr><td>Parcela</td></tr>
																			<tr><td align="center">${dados.parcelamentos[i].digito}/${dados.parcelamentos[i].digitofinal}</td></tr>
																		</table>
																	</td>
																	<td colspan="2" style="font-size:8.5px; border-right: 1px solid; border-bottom: 1px solid;">
																		<table width="100%" cellspacing="1" cellpadding="1">
																			<tr><td>Vencimento</td></tr>
																			<tr><td style="font-weight:bold;" align="center">${this.dataVencimento[i]}</td></tr>
																		</table>
																	</td>
																</tr>
																<tr>
																	<td colspan="3" style="font-size:8.5px; border-right: 1px solid; border-bottom: 1px solid;">
																		<table width="100%" cellspacing="1" cellpadding="1">
																			<tr><td>Agência/Código do beneficiário</td></tr>
																			<tr><td align="center">${res.data[i].agencia}/${res.data[i].conta}-${res.data[i].digito}</td></tr>
																		</table>
																	</td>
																</tr>
																<tr>
																	<tr>
																		<td style="font-size:8.5px; border-right: 1px solid; border-bottom: 1px solid;">
																			<table width="100%" cellspacing="1" cellpadding="1">
																				<tr><td>Nosso Número</td></tr>
																				<tr><td align="center">${res.data[i].carteira}/${res.data[i].calculanossonumero}-${res.data[i].calculadac2}</td></tr>
																			</table>
																		</td>
																		<td colspan="2" style="font-size:8.5px; border-right: 1px solid; border-bottom: 1px solid;">
																			<table width="100%" cellspacing="1" cellpadding="1">
																				<tr><td>Espécie Doc</td></tr>
																				<tr><td align="center">DM</td></tr>
																			</table>
																		</td>
																	</tr>
																</tr>
																<tr>
																	<td colspan="3" style="font-size:8.5px; border-right: 1px solid; border-bottom: 1px solid;">
																		<table width="100%" cellspacing="1" cellpadding="1">
																			<tr><td valign="top">(=) Valor do Documento</td></tr>
																			<tr><td align="center" style="font-weight:bold;">
																					${parseFloat(dados.parcelamentos[i].valorliqtitulo).toLocaleString("pt-br", {style: "currency",currency:"BRL",})}
																			</td></tr>
																		</table>
																	</td>
																</tr>
																<tr>
																	<td colspan="3" style="font-size:8.5px; border-right: 1px solid; border-bottom: 1px solid;">
																		<table width="100%" style="min-height:16px" cellspacing="1" cellpadding="1">
																			<tr><td valign="top">(-) Desconto/Abatimento</td></tr>
																			<tr><td></td></tr>
																		</table>
																	</td>
																</tr>
																<tr>
																	<td colspan="3" style="font-size:8.5px; border-right: 1px solid; border-bottom: 1px solid;">
																		<table width="100%" style="min-height:16px" cellspacing="1" cellpadding="1">
																			<tr><td valign="top">(+) Mora/Multa</td></tr>
																			<tr><td></td></tr>
																		</table>
																	</td>
																</tr>
																<tr>
																	<td colspan="3" style="font-size:8.5px; border-right: 1px solid; border-bottom: 1px solid;">
																		<table width="100%" style="min-height:16px" cellspacing="1" cellpadding="1">
																			<tr><td valign="top">(=) Valor Cobrado</td></tr>
																			<tr><td></td></tr>
																		</table>
																	</td>
																</tr>
																<tr>
																	<td colspan="3" style="font-size:8.5px; border-right: 1px solid; border-bottom: 1px solid;">
																		<table cellspacing="2" cellpadding="1" style="min-height: 45px;">
																			<tr>
																				<td valign="top">
																				<strong> Pagador</strong> <br/>
																					${res.data[i].cliente} <br/>
																					CNPJ/CPF ${res.data[i].cpfcnpj} <br/>
																					${res.data[i].endereco} - ${res.data[i].cep} - ${res.data[i].cidade}-${res.data[i].uf}
																				</td>
																			</tr>
																		</table>
																	</td>
																</tr>
																<tr>
																	<td colspan="3" style="font-size:8.5px; border-right: 1px solid; border-bottom: 1px solid;">
																		<table cellspacing="2" cellpadding="1" style="min-height: 45px;">
																			<td valign="top">
																				<strong> Beneficiário</strong> <br/>
																					${res.data[i].empresa}<br/>
																					CNPJ/CPF ${res.data[i].empresacnpj}<br/>
																					${res.data[i].empresaendereco} - ${res.data[i].empresacep} - ${res.data[i].empresacidade}
																				</td>
																			</tr>
																		</table>
																	</td>
																</tr>
															</table>
														</td>
														<td width="5">&nbsp;</td>
														<td valign="top" width="500px">
															<table cellpadding="1" cellspacing="0">
																<tr height="30" style="font-size:9.5px">
																	<td style="border-left: 1px solid; border-bottom: 1px solid;" colspan="auto" align="center">
																		<img style="width:80px" src="data:image/gif;base64,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" />
																	</td>
																	<td style="border-left: 1px solid; border-bottom: 1px solid;" colspan="auto" align="center">
																		<img style="width:30px" src="data:image/gif;base64,R0lGODlhVgArALMAAIiIiLu7u93d3ZmZmREREe7u7qqqqszMzFVVVSIiImZmZjMzM0RERHd3dwAAAP///yH5BAAAAAAALAAAAABWACsAAAT/8MlJq7046827/2AojmRpnmiqrmzrvnAsz3Rt33iu73zv/xIBwEEkAAqbAdEhyCSIgc5zSV1GS4EqMXHICAjL5kUJlWqr11EBfE5kEFRx5UBNa6bnMmlIBEgYSwYXBlVyE4R1JAJLCyYDCg4IE3R9FmuFFAdwaCQLRYYpiA5+FZtsTBRUp3YffA6CLAdTBEgUiAkNYalEC66sHZcODCwFqqzBBq6GRJJkDr8cyrFUAxaQDgoP0hMLsM7QGsHZLFlUDLUPiLTaumNWIa5dxBKukg8FU9XsRKAT3xVnKnhy0CjGNVTX7O1D5U7PhICTlpCC4UxQnir6KPzbVYXCthMFaADAGSeh4oOL1CxsfKiFwqaCKdgQoHCwC8olGf29+8CmwYqDCJC4GobhY4WVHCiNWvHlorwLRjXu7CAKHIkDpxJliKrTYbR2K0KeOrKBa8mpX/kBWcu2rdu3cOPKnUu3rt27ePPq3RABADs=" />
																	</td>
																	<td style="border-left: 1px solid; border-bottom: 1px solid; font-size:9.5px;" colspan="7" width="350px" align="right" valign="center"><strong>${res.data[i].numeroboleto}</strong></td>
																</tr>
																<tr>
																	<td colspan="6" style="font-size:8.5px; border-left: 1px solid; border-bottom: 1px solid;">
																		<table width="100%" cellspacing="2" cellpadding="1">
																			<tr><td>Local de Pagamento</td></tr>
																			<tr><td align="left">Pague pelo aplicativo, internet ou em agências e correspondentes</td></tr>
																		</table>
																	</td>
																	<td colspan="2" style="font-size:8.5px; border-left: 1px solid; border-bottom: 1px solid;">
																		<table width="100%" cellspacing="1" cellpadding="1">
																			<tr><td>Vencimento</td></tr>
																			<tr><td style="font-weight:bold;" align="center">${this.dataVencimento[i]}</td></tr>
																		</table>
																	</td>
																</tr>
																<tr>
																	<td valign="top" colspan="6" style="font-size:8.5px; border-left: 1px solid; border-bottom: 1px solid;">
																		<table style="position:relative" width="100%" cellspacing="1" cellpadding="1">
																			<tr><td >Beneficiário</td></tr>
																			<tr>
																				<td align="left">
																					<strong> ${res.data[i].cedente}</strong> 
																					<span style="position: absolute;right: 25px;"><strong>CNPJ/CPF:</strong> ${res.data[i].empresacnpj}</span>
																				</td>
																			</tr>
																			<tr><td align="left">${res.data[i].empresaendereco} - ${res.data[i].empresacep} - ${res.data[i].empresabairro} - ${res.data[i].empresacidade}</td></tr>
																		</table>
																	</td>
																	<td colspan="2" style="font-size:8.5px; border-left: 1px solid; border-bottom: 1px solid;">
																		<table width="100%" cellspacing="1" cellpadding="1">
																			<tr><td>Agência/Código do beneficiário</td></tr>
																			<tr><td align="center">${res.data[i].agencia}/${res.data[i].conta}-${res.data[i].digito}</td></tr>
																		</table>
																	</td>
																</tr>
																<tr>
																	<td colspan="2" style="font-size:8.5px; border-left: 1px solid; border-bottom: 1px solid;">
																		<table width="100%" cellspacing="1" cellpadding="1">
																			<tr><td>Data do Documento</td></tr>
																			<tr><td align="center">${new Date(new Date()).toLocaleDateString("pt-BR")}</td></tr>
																		</table>
																	</td>
																	<td colspan="2" style="font-size:8.5px; border-left: 1px solid; border-bottom: 1px solid;">
																		<table width="100%" cellspacing="1" cellpadding="1">
																			<tr><td>Espécie Doc</td></tr>
																			<tr><td align="center">DM</td></tr>
																		</table>
																	</td>
																	<td colspan="2" style="font-size:8.5px; border-left: 1px solid; border-bottom: 1px solid;">
																		<table width="100%" cellspacing="1" cellpadding="1">
																			<tr><td>Aceite</td></tr>
																			<tr><td align="center">${res.data[i].aceite}</td></tr>
																		</table>
																	</td>
																	<td colspan="2" style="font-size:8.5px; border-left: 1px solid; border-bottom: 1px solid;">
																		<table width="100%" cellspacing="1" cellpadding="1">
																			<tr><td>Nosso Número</td></tr>
																			<tr><td align="center">${res.data[i].carteira}/${res.data[i].calculanossonumero}-${res.data[i].calculadac2}</td></tr>
																		</table>
																	</td>
																</tr>
																<tr>
																	<td colspan="2" valign="top" style="font-size:8.5px; border-left: 1px solid; border-bottom: 1px solid;">
																		<table width="100%" cellspacing="1" cellpadding="1">
																			<tr><td >Uso do Banco</td></tr>
																			<tr><td align="center"></td></tr>
																		</table>
																	</td>
																	<td colspan="2" style="font-size:8.5px; border-left: 1px solid; border-bottom: 1px solid;">
																		<table width="100%" cellspacing="1" cellpadding="1">
																			<tr><td>Carteira</td></tr>
																			<tr><td align="center">${res.data[i].carteira}</td></tr>
																		</table>
																	</td>
																	<td colspan="2" style="font-size:8.5px; border-left: 1px solid; border-bottom: 1px solid;">
																		<table width="100%" cellspacing="1" cellpadding="1">
																			<tr><td>Espécie</td></tr>
																			<tr><td align="center">R$</td></tr>
																		</table>
																	</td>
																	<td colspan="2" style="font-size:8.5px; border-left: 1px solid; border-bottom: 1px solid;">
																		<table width="100%" cellspacing="1" cellpadding="1">
																			<tr><td>(=) Valor do Documento</td></tr>
																			<tr>
																				<td style="font-weight:bold;" align="center">
																					${parseFloat(dados.parcelamentos[i].valorliqtitulo).toLocaleString("pt-br",{style: "currency",currency:"BRL",})}
																				</td>
																			</tr>
																		</table>
																	</td>
																</tr>
																<tr>
																	<td valign="top" rowspan="4" colspan="6" style="font-size:8.5px; border-left: 1px solid; border-bottom: 1px solid;">
																		<table width="100%" cellspacing="1" cellpadding="1">
																			<tr><td>Instruções (Todas as informações abaixo são de exclusiva responsabilidade do beneficiário)</td></tr>
																			<tr>
																				<td style="font-weight:bold;">
																					${res.data[i].instrucoes[0]}<br/>
																					${res.data[i].instrucoes[1]}<br/>
																					${res.data[i].instrucoes[2]}
																				</td>
																			</tr>
																		</table>
																	</td>
																</tr>
																<tr>
																	<td colspan="2" style="font-size:8.5px; border-left: 1px solid; border-bottom: 1px solid;">
																		<table width="100%" cellspacing="1" cellpadding="1" style="min-height:16px">
																			<tr><td valign="top">(-) Desconto/Abatimento</td></tr>
																			<tr><td style="font-weight:bold;"></td></tr>
																		</table>
																	</td>
																</tr>
																<tr>
																	<td colspan="2" style="font-size:8.5px; border-left: 1px solid; border-bottom: 1px solid;">
																		<table width="100%" cellspacing="1" cellpadding="1" style="min-height:16px">
																			<tr><td valign="top">(+) Mora/Multa</td></tr>
																			<tr><td style="font-weight:bold;"></td></tr>
																		</table>
																	</td>
																</tr>
																<tr>
																	<td colspan="2" style="font-size:8.5px; border-left: 1px solid; border-bottom: 1px solid;">
																		<table width="100%" cellspacing="1" cellpadding="1" style="min-height:16px">
																			<tr><td valign="top">(=) Valor Cobrado</td></tr>
																			<tr><td style="font-weight:bold;"></td></tr>
																		</table>
																	</td>
																</tr>
																<tr>
																	<td colspan="8" style="font-size:8.5px; border-left: 1px solid; border-bottom: 1px solid;">
																		<table width="100%" style="position:relative" cellspacing="2" cellpadding="1">
																			<tr>
																				<td>
																					<strong>Pagador:</strong><br/>
																					${res.data[i].cliente} <span style="position: absolute;right: 55px;"><strong>CNPJ/CPF:</strong>${res.data[i].cpfcnpj}</span><br/>
																					${res.data[i].endereco} - ${res.data[i].cep} - ${res.data[i].cidade}-${res.data[i].uf}
																				</td>
																			</tr>
																			<tr>
																				<td>
																					<strong>Beneficiário Final:</strong><br/>
																					${res.data[i].empresa} <span style="position: absolute;right: 55px;"><strong>CNPJ/CPF:</strong> ${res.data[i].empresacnpj}</span>
																				</td>
																			</tr>
																		</table>
																	</td>
																</tr>
																<tr>
																	<td colspan="4">
																		<img style="margin-top:5px; width:350px; height:45px;" src="data:image/png;base64,${res.data[i].base64}" />
																	</td>
																	<td colspan="4" style="font-size:10.5px;" align="right">
																		<strong> Ficha de Compensação</strong><br/>
																		Autenticação Mecânica
																	</td>
																</tr>
															</table>
														</td>
													</tr>
												</table>
											</div
                                        </body>
                                    </html>
                                `;
							if ( i != 2 && i != 5 && i != 8 && i != 11 && i != 14 && i != 17 ){
								htmlContent += `<img style="margin-top:25px; margin-bottom:5px; margin-left:20px; width:740px; height:20px;" src="data:image/png;base64,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" />`;
							}
						}
						let data = new Date();
						let nome = `carne_${
							data.toISOString().split(".")[0]
						}.pdf`;
						html2pdf(htmlContent, {
							margin: 5,
							filename: nome,
							image: { type: "jpeg", quality: 1 },
							html2canvas: { dpi: 192, letterRendering: true, scale: 2 },
							jsPDF: {
								unit: "pt",
								format: "a4",
								orientation: "portrait",
							},
						});
					} else {
						this.dialogErro.title = "Erro";
						if (res.data.erro) {
							this.dialogErro.msg = res.data.erro;
						} else {
							this.dialogErro.msg =
								"Não foi possível emitir o boleto";
						}
						this.dialogErro.icon = "mdi-alert-circle-outline";
						this.dialogErro.iconColor = "red";
						this.dialogErro.status = true;
					}
				})
				.catch(() => {
					this.carregando = false;
					this.dialogLoading = false;
					this.dialogErro.title = "Erro";
					this.dialogErro.msg = "Não foi possível emitir o boleto";
					this.dialogErro.icon = "mdi-alert-circle-outline";
					this.dialogErro.iconColor = "red";
					this.dialogErro.status = true;
				});
		},
		async init() {
			this.busca.idfilial = this.usuario.idfilial;
			if (this.$route.params.idcliente) {
				this.busca.idcliente = this.$route.params.idcliente;
				this.busca.titulo = this.$route.params.titulo;
				await this.carregarClientes(`${this.busca.idcliente}`);
			}
		},
	},
	watch: {
		search: function (val) {
			this.carregarClientes(val);
		},
		searchMobile: function (val) {
			this.carregarClientes(val);
		},
	},
	created() {
		this.init();
	},
};
</script>
